/* eslint-disable no-use-before-define */
import React from 'react'
import { hideModal } from '../twd/twd'

const sectionArray = [{
    id: 'executive_summary',
    label: 'Executive summary',
    summary: 'Get a snapshot view of your complete portfolio, including summary totals, averages for portfolio holdings, asset class and credit quality diversification and maturity and duration exposure'
}, {
    id: 'position_details',
    label: 'Position details',
    summary: 'In-depth view on all fixed income positions in your portfolio, current evaluated pricing, and unrealized gains/loss calculations'
}, {
    id: 'reinvestment_proceeds',
    label: 'Reinvestment proceeds',
    summary: 'Gain quick perspective on upcoming reinvestment proceeds (coupon payments, maturing principal, called bond proceeds) due from your holdings'
}, {
    id: 'coupon_cashflow',
    label: 'Coupon cash flow',
    summary: 'Easily review and analyze your portfolios income and forward-looking monthly cash flows based on asset class, distribution by taxable or tax-exempt positions, and coupon payment date'
}, {
    id: 'credit_ratings_history',
    label: 'Credit ratings history',
    summary: 'Access current and historical credit rating history from Moody’s and S&P, along with credit watch and outlook expectations'
}, {
    id: 'muni_position_attributes',
    label: 'Muni position attributes',
    summary: 'Acquire further insights on your municipal holdings with position analysis covering the type of muni and funding purpose, the holdings distribution by state, and insurance and credit enhancements'
}, {
    id: 'corp_position_attributes',
    label: 'Corp position attributes',
    summary: 'Acquire further insights on your corporate holdings with position analysis covering sector distribution and debt ranking distribution'
}, {
    id: 'fdic_certificate_concentration',
    label: 'FDIC certificate # concentration',
    summary: 'Understand your CD position concentration by individual FDIC Certificate Number'
}].map ( (r, i) => ({
    ...r,
    index: i,
    src: `./resources/images/portfolio-report-modal/${r.id}.jpg`
}))

const sections = sectionArray
    .reduce( (x, s) => { return { ...x, [s.id]: s}}, {})


export default ({name, from}) => {

    const [section, setSection] = React.useState(
        sections[name] || sectionArray[0]
    )

    return <React.Fragment>
    <div
        data-name="offerings-modal-close-link"
        className="modal-dialog modal-lg report">
    <div className="modal-content" style={{padding:'30px 14px'}}>
    <div className="modal-header">

        <button
            className="close"
            aria-label="close"
            data-name="offerings-modal-close-link"
            type="button"
            onClick={() => {
                hideModal()
            }}>
            <i className="material-icons" aria-hidden="true">close</i>
        </button>

    <div className="row">
    <div className="flex-xs-12 flex-md-8 text-center prospect auto-margin">
        <h3>{section.label}</h3>
        <p>{section.summary}</p>
    </div>
    </div>

    <img
        alt={section.label}
        style={{width:'100%', objectFit:'contain' }}
        src={section.src}
    />

    </div>

    <div className='modal-footer'>
    <div className="container" style={{background:"#ffffff" }}>

    <div className="row vertical-offset-xs">
    <div className="col-md-12 select-wrapper text-center">
        <label htmlFor={'portfolio-report-modal-select'}>Explore other features:</label>
        &nbsp;
        <select
            id='portfolio-report-modal-select'
            className='form-control'
            style={{
                display: 'inline-block',
                width:'fit-content',
                paddingRight:'25px',
                marginLeft: '5px'
            }}
            value={section.id}
            onChange={(e) => {
                setSection(sections[e.target.value])
            }}
        >
            {sectionArray.map((a, i) =>
                <option key={i} value={a.id}>{a.label}</option>
            )}
        </select>
    </div>
    </div>

    <div className="row vertical-offset-sm">
    <div className="col-md-12 text-center">
        <ul className="pagination">

        <li className='previous'>
            <button
                className='btn-link'
                disabled={section.index===0}
                aria-label="previous"
                onClick={() => {
                    setSection(sectionArray[section.index - 1])
                }}>
                <i className="material-icons" aria-hidden="true">chevron_left</i>
            </button>
        </li>

        {sectionArray.map((s, i) => {
            const isCurrent = section.index === i
            return <li
                key={`portfolio-report-modal-section-${i}`}
                className={ isCurrent ? 'active' : ''}
            >
            <button
                className='btn-link'
                { ...(isCurrent
                    ? {
                        'aria-current': 'page',
                        style:{
                            color:'#242424',
                            fontWeight:'500',
                            textDecoration:'none',
                            cursor:'not-allowed',
                            pointerEvents:'none'
                        }}
                    : {}) }
                aria-label={`page ${i+1} ${s.label}`}
                onClick={() => {
                    if (isCurrent) return
                    setSection(sectionArray[i])
                }}
                >
                    {i+1}
                </button>
            </li>
        })}

        <li className="next">
            <button
                className='btn-link'
                disabled={section.index===(sectionArray.length-1)}
                aria-label="next"
                onClick={() => {
                    setSection(sectionArray[section.index + 1])
                }}>
                <i className="material-icons" aria-hidden="true">chevron_right</i>
            </button>
        </li>
        </ul>
    </div>
    </div>

    <div className="row vertical-offset-xs">
    <div className="col-md-12 text-center">
        <button
            className="btn-link"
            aria-label="close"
            data-name="portfolio-report-modal-close-link"
            type="button"
            onClick={() => {
                hideModal()
            }}>
            Close
        </button>
    </div>
    </div>
    </div>
    </div>
    </div>
    </div>

    </React.Fragment>
}
